import { loginApi } from '@/api/login'
import { addRecentLoginList } from '@/utils/cache'
import Cookie from '@/utils/localStorage'
const show_from = Number(Cookie.get('show_from')) || 0

// 登录
export const login = (query) => {
  return new Promise((resolve, reject) => {
    try {
      try {
        query.show_from = show_from
      } catch (err) {
        console.error(err)
      }
      loginApi(query)
        .then((res) => {
          const data = res.data
          const resCom = res.resp_common
          if (resCom.ret === 0) {
          // 保存到登录列表里
            addRecentLoginList(data.user_info, data.token)
          }
          resolve(res)
        })
    } catch (error) {
      console.error(error)
      reject(error)
    }
  })
}

// 快速登录
export const quickLogin = (query) => {
  if (query && query.userInfo && query.token) {
    const data = {
      login_token: query.token,
      login_type: 4,
    }
    return login(data)
  }
}
